import { matcher, isMatch } from "matcher";
export { matcher, isMatch };
export function isWildcard(str: string): boolean {
  return str.includes("!") || str.includes("*");
}
